// ===================================================
// formatDate.js — 날짜 문자열을 한국어로 변환하는 유틸
// 예: "2026-03-14" → "2026년 3월 14일"
// 여러 화면에서 공통으로 사용됩니다.
// ===================================================

export function formatDate(dateStr) {
  const [year, month, day] = dateStr.split('-');
  return `${year}년 ${month}월 ${day}일`;
}
